import { Notification } from 'element-ui';

const defaultSuccessDuration = 1800;
const defaultErrorDuration = 4000;

export function showSuccessNotification(message, duration = defaultSuccessDuration, showCloseOnNotification = true) {
  const windowSize = { // TODO: Refactor in util function
    width: window.innerWidth || document.body.clientWidth,
    height: window.innerHeight || document.body.clientHeight,
  };
  let showClose = showCloseOnNotification;

  if (windowSize.width < 768) showClose = true;

  Notification({
    customClass: 'notification-container',
    title: 'Success',
    type: 'success',
    message,
    duration,
    showClose,
  });
}

export function showErrorNotification(message, duration = defaultErrorDuration, showCloseOnNotification = true) {
  const windowSize = {
    width: window.innerWidth || document.body.clientWidth,
    height: window.innerHeight || document.body.clientHeight,
  };
  let showClose = showCloseOnNotification;

  if (windowSize.width < 768) showClose = true;
  Notification({
    customClass: 'notification-container',
    title: 'An Error occured.',
    type: 'error',
    message,
    duration,
    showClose,
  });
}
